import { useEffect, useState } from 'react';
import { Button, Groupper, Header, Icon, Input, Pagination, Table } from 'react-frontier';
import { Link } from 'react-router-dom';
import { InventoryWarehouse } from '../SiteClasses';
import { CreateWarehouseModal } from '../components';
import { useBreadcrumbs, useUser } from '../hooks';
import UserAccess from '../UserAccess';
import API from '../API';
import { bindClick } from '../SiteUtil';

const PAGE_SIZE = 20;

var WarehousesList = ()=>{
	var { setTitle } = useBreadcrumbs();
	var { hasAccess } = useUser();
	var [warehouses, setWarehouses] = useState<InventoryWarehouse[]>(null);
	var [loadError, setLoadError] = useState<string>(null);
	var [loading, setLoading] = useState<boolean>(false);
	var [filter, setFilter] = useState<string>('');
	var [searchWarehouses, setSearchWarehouses] = useState<InventoryWarehouse[]>(null);
	var [searchTimeout, setSearchTimeout] = useState<any>(null);
	var [searching, setSearching] = useState<boolean>(false);
	var [page, setPage] = useState<number>(0);
	var [createModal, setCreateModal] = useState<boolean>(false);
	useEffect(()=>{
		setTitle('Almacenes');
		get();
	}, []);

	var get = (get_page?: number)=>{
		var offset = (get_page > 0) ? Math.max(0, (get_page || page) * PAGE_SIZE) : 0;

		setLoading(true);
		API.getWarehouses(offset, PAGE_SIZE).then(res=>{
			if(res.error) return setLoadError(res.message);
			setWarehouses(res.data);
		}).catch(()=>{
			setLoadError('Hubo un error inesperado cargando los almacenes.');
		}).finally(()=>{
			setLoading(false);
		});
	};

	var onSearchChange = (val: string)=>{
		setFilter(val);
		setPage(0);
		if(searchTimeout) clearTimeout(searchTimeout);
		if(val.length < 3){
			setSearchWarehouses(null);
			return;
		}
		setSearchTimeout(setTimeout(()=>{
			search(val);
		}, 500));
	};

	var search = (query: string)=>{
		setSearching(true);
		setSearchWarehouses(null);
		setPage(0);
		API.searchWarehouses(query, 0, PAGE_SIZE).then(res=>{
			if(res.error) return setLoadError(res.message);
			setSearchWarehouses(res.data);
		}).catch(()=>{
			setLoadError('Hubo un error inesperado buscando almacenes.');
		}).finally(()=>{
			setSearching(false);
		});
	};

	var onPageChange = (p: number)=>{
		setLoading(true);
		setPage(p);
		get(p);
	};

	var onCreated = (warehouse: InventoryWarehouse)=>{
		setWarehouses(prev => [warehouse, ...prev]);
		setCreateModal(false);
	};

	if(loadError) return <Header text='Error' subtext={loadError} />;
	if(!warehouses) return <Header loading text='Cargando' />;

	var shown_warehouses = searchWarehouses || warehouses;

	return <Groupper
		title='Almacenes'
		width={900}
		style={{ marginTop: 20 }}
		titleRight={hasAccess(UserAccess.INVENTORY.CREATE_WAREHOUSES) && (
			<Button iconName='plus-circle' color='black' text='Agregar' size='small' onClick={()=> setCreateModal(true)} />
		)}
	>
		<Input
			placeholder='Buscar...'
			value={filter}
			onChange={onSearchChange}
		/>
		<Table
			striped
			selectable
			className='first last'
			style={{ marginTop: 15 }}
			headers={['ID', 'Nombre', 'Descripción', 'Ciudad']}
			collapsingIndexes={[0]}
			footer={(!!shown_warehouses && shown_warehouses.length >= PAGE_SIZE || page !== 0) && (
				<Table.Cell row colSpan={4}>
					<div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
						<Pagination page={page} onPageChange={onPageChange} hasNext={shown_warehouses.length >= PAGE_SIZE} />
					</div>
				</Table.Cell>
			)}
		>
			{searching || loading ? (
				<Table.Cell row colSpan={4}>
					<Header loading text='Cargando' />
				</Table.Cell>
			) : shown_warehouses.length === 0 ? (
				<Table.Cell row className='empty' colSpan={4}>
					No se encontraron almacenes
				</Table.Cell>
			) : shown_warehouses.map(warehouse=>(
				<Table.Row
					key={warehouse.warehouse_id}
					compact
					as={Link}
					to={`/warehouses/${warehouse.warehouse_id}`}
					data={[
						warehouse.warehouse_id,
						warehouse.warehouse_name,
						warehouse.description || <Icon name='minus' />,
						warehouse.location_city || <Icon name='minus' />,
					]}
				/>
			))}
		</Table>
		<CreateWarehouseModal
			open={createModal}
			onClose={bindClick(setCreateModal, false)}
			onCreate={onCreated}
		/>
	</Groupper>;
};

export default WarehousesList;
